export default __webpack_public_path__ + "static/media/CountCouple_00.5563aa22.png";